import { useTranslation } from 'react-i18next';
import { CategoryType } from '@data/sdk/match';
import { Namespace } from '@data/utils/enums';
import { AntdInput } from '@ui/components';
import { ClassificationTable } from '../components';
import { useQuestionClassification } from '../hooks';

const QuestionIcdCodes = () => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const {
    current,
    pageSize,
    isLoading,
    categories,
    handleTableChange,
    openCreateCategory,
    searchString,
    handleSearchChange,
  } = useQuestionClassification(CategoryType.IcdCode, true);

  return (
    <div>
      <AntdInput
        value={searchString}
        onChange={handleSearchChange}
        placeholder={t('question_page.classification.search')}
        className="mt-4 w-full md:w-[340px]"
      />
      <ClassificationTable
        type={CategoryType.IcdCode}
        includeIcdCodes
        current={current}
        pageSize={pageSize}
        isLoading={isLoading}
        total={categories?.count || 0}
        categories={categories?.items}
        handleTableChange={handleTableChange}
        openCreateCategory={openCreateCategory}
      />
    </div>
  );
};

export default QuestionIcdCodes;
